<!-- eslint-disable -->
<template>
    <el-container>
      <div style="padding: 20px 0; width: 100%;">
        <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
          <div style="display: flex; min-width: 1400px;">
            <div style="width: 820px;">
              <el-form-item label="商品标题"
                  :label-width="formLabelWidth"
                  prop="title"
                  :rules="[
                  { required: true, message: '请输入商品标题', trigger: 'blur' }
                  ]">
                  <el-input type="text" v-model="form.title" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="商品分类"
                  :label-width="formLabelWidth"
                  prop="category_id"
                  :rules="[
                  { required: true, message: '请选择商品分类', trigger: 'blur' }
                  ]">
                  <el-select v-model="form.category_id" placeholder="请选择商品分类">
                      <el-option
                          v-for="item in categoryList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="优惠券"
                  v-if="form.category_id == 5"
                  :label-width="formLabelWidth"
                  prop="coupon_id"
                  :rules="[
                  { required: true, message: '请选择优惠券', trigger: 'blur' }
                  ]">
                  <el-select v-model="form.coupon_id" placeholder="请选择优惠券">
                      <el-option
                          v-for="item in couponList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="上传封面"
                  class="upload-image"
                  :label-width="formLabelWidth"
                  :rules="[
                        { required: true, message: '请上传封面', trigger: 'blur' }
                      ]"
                  prop="cover">
                  <el-upload
                      class="avatar-uploader"
                      name="file"
                      accept="image/png, image/jpeg"
                      :data="{type: 'goods'}"
                      :action="uploadImageUrl"
                      :show-file-list="false"
                      :on-success="handleImageSuccess"
                      :before-upload="beforeImageUpload"
                      v-loading="loadingImage"
                      element-loading-text="上传中..."
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)">
                      <el-image v-if="form.cover" :src="form.cover" class="avatar">
                          <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                          </div>
                      </el-image>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1MB，尺寸 1 : 1</div>
                  </el-upload>
              </el-form-item>
              <el-form-item label="售价"
                  :label-width="formLabelWidth"
                  prop="price"
                  :rules="[
                  { required: true, message: '请输入售价', trigger: 'blur' }
                  ]">
                  <el-input type="number" v-model="form.price" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="市场价"
                  :label-width="formLabelWidth"
                  prop="market_price"
                  :rules="[
                  { required: true, message: '请输入市场价', trigger: 'blur' }
                  ]">
                  <el-input type="number" v-model="form.market_price" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所需积分"
                  :label-width="formLabelWidth"
                  prop="integral"
                  :rules="[
                  { required: true, message: '请输入所需积分', trigger: 'blur' }
                  ]">
                  <div style="display: flex;">
                    <div style="padding-right: 10px;">
                      <el-input type="number" readonly v-model="form.integral" autocomplete="off"></el-input>
                    </div>
                    <div><el-checkbox @change="isIntegralChange" v-model="is_integral" :true-label="1" :false-label="0" label="积分兑换"></el-checkbox></div>
                  </div>
              </el-form-item>
              <el-form-item label="库存"
                  :label-width="formLabelWidth"
                  prop="stock_num"
                  :rules="[
                  { required: true, message: '请输入库存', trigger: 'blur' }
                  ]">
                  <el-input type="number" v-model="form.stock_num" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="单位"
                  :label-width="formLabelWidth"
                  prop="company"
                  :rules="[
                  { required: true, message: '请输入单位', trigger: 'blur' }
                  ]">
                  <el-input type="text" v-model="form.company" autocomplete="off"></el-input>
              </el-form-item>
            </div>

            <div style="width: 820px;">
              <el-form-item label="商品详情"
                  :label-width="formLabelWidth"
                  prop="detail"
                  :rules="[
                  { required: true, message: '请输入商品详情', trigger: 'blur' }
                  ]">
                  <div id="editor1" style="border: 1px solid #ccc;"></div>
                  <div id="editor2" style="border: 1px solid #ccc; height: 510px;"></div>
              </el-form-item>
              <el-form-item label="状态"
                  :label-width="formLabelWidth"
                  prop="is_put"
                  :rules="[
                  { required: true, message: '请选择状态', trigger: 'blur' }
                  ]">
                  <el-radio v-model="form.is_put" :label="1" border>上架</el-radio>
                  <el-radio v-model="form.is_put" :label="2" border>下架</el-radio>
              </el-form-item>
            </div>
          </div>

          <div style="text-align: center;">
            <el-button @click="reset">重置</el-button>
            <el-button type="primary" @click="addData('form')">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {GoodsIndex, GoodsAdd, GoodsFormInit} from "@/utils/request.js"
    import E from 'wangeditor'
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    id: 0
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增商品",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    title: "",
                    category_id: "",
                    coupon_id: "",
                    cover: "",
                    price: "",
                    market_price: "",
                    integral: 0,
                    stock_num: "",
                    company: "",
                    detail: "",
                    is_put: 1,
                },
                multipleSelection: [],
                loadingImage: false,
                editorObj: null,
                categoryList: [],
                couponList: [],
                is_integral: "0"
            }
        },
        created() {
            if (this.$route.params.id > 0) {
              this.data.id = this.$route.params.id
            }

            const that = this
            setTimeout(function() {
              that.showEditor()
            }, 200)

            this.getFormInit()
        },
        computed: mapState(["power"]),
        methods: {
            showEditor() {
              const that = this
              const editor = new E('#editor1', '#editor2')
              this.editorObj = editor

              editor.customConfig.zIndex = 100
              editor.customConfig.uploadImgMaxSize = 5 * 1024 * 1024
              editor.customConfig.uploadImgMaxLength = 1
              editor.customConfig.uploadImgServer = this.uploadImageUrl
              editor.customConfig.uploadFileName = 'file'
              editor.customConfig.uploadImgParams = {
                  type: 'goods'
              }
              editor.customConfig.uploadImgHooks = {
                  before: function (xhr, editor, files) {
                      // 图片上传之前触发
                  },
                  success: function (xhr, editor, result) {
                      // 图片上传并返回结果，图片插入成功之后触发
                      // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                  },
                  fail: function (xhr, editor, result) {
                      that.$message.error('图片插入出错');
                  },
                  error: function (xhr, editor) {
                      that.$message.error('图片上传出错');
                  },
                  timeout: function (xhr, editor) {
                      that.$message.error('图片上传超时');
                  },
                  customInsert: function (insertImg, res, editor) {
                      if (res.code == 200) {
                        var url = res.data.url
                        insertImg(url)
                      } else {
                        that.$message.error(res.msg);
                      }
                  }
              }
              editor.customConfig.onchange = (html) => {
                  this.form.detail = html
              }

              editor.customConfig.colors = [
                  '#000000',
                  '#eeece0',
                  '#1c487f',
                  '#4d80bf',
                  '#c24f4a',
                  '#8baa4a',
                  '#7b5ba1',
                  '#46acc8',
                  '#f9963b',
                  '#ffffff',
                  '#ff0000'
              ]

              editor.create()
              editor.txt.html(this.form.detail)
            },
            getFormInit() {
                this.loading = true
                GoodsFormInit(this.data).then((res) => {
                    if (res.code == 200) {
                        this.categoryList = res.data.categoryList
                        this.couponList = res.data.couponList

                        if (res.data.data.id !== undefined) {
                          this.form = {
                              id: res.data.data.id,
                              title: res.data.data.title,
                              category_id: res.data.data.category_id,
                              coupon_id: res.data.data.coupon_id == 0 ? '' : res.data.data.coupon_id,
                              cover: res.data.data.cover,
                              price: res.data.data.price,
                              market_price: res.data.data.market_price,
                              integral: res.data.data.integral,
                              stock_num: res.data.data.stock_num,
                              company: res.data.data.company,
                              detail: res.data.data.detail,
                              is_put: res.data.data.is_put > 0 ? res.data.data.is_put : 1,
                          }

                          if (res.data.data.integral > 0) {
                            this.is_integral = 1
                          } else {
                            this.is_integral = 0
                          }
                          this.editorObj.txt.html(res.form.detail)
                        }
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        GoodsAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.initForm()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            reset() {
              this.$confirm("确定要重置表单数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "error"
              }).then(() => {
                  this.initForm()
              }).catch(() => {
                  // 取消操作
              });
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    title: "",
                    category_id: "",
                    coupon_id: "",
                    cover: "",
                    price: "",
                    market_price: "",
                    integral: "0",
                    stock_num: "",
                    company: "",
                    detail: "",
                    is_put: 1,
                }
                this.editorObj.txt.html('')
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增商品"
            },
            handleImageSuccess(res, file) {
                if (res.code == 200) {
                    this.form.cover = res.data.url
                } else {
                    this.$message.error(res.msg);
                }
                this.loadingImage = false
            },
            beforeImageUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 1;

                if (!isLt2M) {
                    this.$message.error("上传封面图片大小不能超过 1MB!");
                }
                this.loadingImage = true
                return isLt2M;
            },
            priceChaneg(val) {
              this.form.integral = this.form.price * 100
            },
            isIntegralChange(val) {
              if (val == 1) {
                this.form.integral = this.form.price * 100
              } else {
                this.form.integral = 0
              }
            }
        }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 161px; /* 161的参数都是默认的比例 */
        height: 161px;
        line-height: 150px;
        text-align: center;
    }
    .avatar {
        width: 161px; /* 161的参数都是默认的比例 */
        height: 161px;
        display: block;
    }
    .image-slot {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28px;
    }
    .upload-image .el-form-item__content {
        line-height: 15px;
    }
</style>
